import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        title: String,
        text: String,
        url: String,
        trackUrl: String
    }

    async share(event) {
        event.preventDefault()
        this.trackClick("native")

        const shareData = {
            title: this.titleValue,
            text: this.textValue,
            url: this.urlValue
        }

        if (navigator.share) {
            try {
                await navigator.share(shareData)
            } catch (err) {
                console.log("Error sharing:", err)
            }
        } else {
            this.openWhatsApp()
        }
    }

    shareWhatsapp(event) {
        if (event) event.preventDefault()
        this.trackClick("whatsapp")
        this.openWhatsApp()
    }

    openWhatsApp() {
        const text = `${this.textValue}\n${this.urlValue}`
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(text)}`
        window.open(whatsappUrl, '_blank')
    }

    copyLink(event) {
        event.preventDefault()
        this.trackClick("copy")
        navigator.clipboard.writeText(this.urlValue).then(() => {
            // You could dispatch an event here to show a toast
            const flash = document.getElementById("flash-messages")
            if (flash) {
                const notice = document.createElement("div")
                notice.className = "rounded-lg border border-emerald-500/30 bg-emerald-900/40 px-4 py-3 text-sm text-emerald-200 backdrop-blur-sm shadow-sm flex items-center gap-2 max-w-sm ml-auto animate-in fade-in slide-in-from-right-5"
                notice.innerHTML = `
           <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" /></svg>
           Enlace copiado al portapapeles
         `
                flash.appendChild(notice)
                setTimeout(() => notice.remove(), 3000)
            }
        })
    }

    trackClick(channel) {
        if (!this.hasTrackUrlValue) return

        const token = document.querySelector("meta[name='csrf-token']")?.content
        fetch(this.trackUrlValue, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": token
            },
            body: JSON.stringify({ channel })
        }).catch(() => {})
    }
}
